export const PRIVACY_INFO_POLICY = `개인정보 수집, 이용 및 제공

■ 수집하는 개인정보의 항목
    - 이름 , 휴대전화번호 , 결제승인정보 , 결제기록 , 접속 IP 정보
    
■ 개인정보의 수집 및 이용목적
    - 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 구매 및 요금결제 자료
    - 원할한 숙박을 위한 SMS발송, 만14세 미만 아동 개인정보 수집시 법정 대리인 동의여부 확인, 불만처리 등 민원처리, 고지사항 전달<br>
    
■ 개인정보의 보유 및 이용기간
제공하는 서비스를 받는 동안 고객님의 개인 정보는 숙박시설에서 보유하며 서비스 제공을 위해 이용하게 됩니다. 단, 숙박시설 고객의 등록 정보는 예약 접수처리 외에 어떠한 용도로도 열람 또는 이용될 수 없도록 처리됩니다. 또한, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.<br>
    - 제공정보 보유기간 : 1년이내
    - 기타 보존 항목 : 접속 로그 , 결제기록
    - 보존 근거 : 전자상거래등에서의 소비자보호에 관한 법률- 보존 기간 : 3년
    - 계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)
    - 대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)
    - 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률)`;
